module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-4_SE-ee97e0e50a1b1f06a5dd37e508016206.svg";